import React from 'react';

import { useAnalyticsQueryParams } from '@candu-ai/analytics/search';
import { QueryId } from '@candu-ai/analytics/types';
import { HistogramGraph } from 'craft/containers/Toolbox/tabs/InteractionAnalytics/HistogramGraph';
import { useTooltipMultiseriesApi } from 'dashboard/pages/Content/pages/Analytics/useTooltipMultiseriesApi';

interface Props {
  documentNodeId: string;
  contentId: string;
}

export const Flow = ({ contentId, documentNodeId }: Props) => {
  const queryParams = useAnalyticsQueryParams({
    contentId,
  });

  const queryParamsWithNodeId = useAnalyticsQueryParams({
    documentNodeId,
    contentId,
  });

  const flowMultiseries = useTooltipMultiseriesApi(
    QueryId.NodeChildLabelsTable,
    queryParamsWithNodeId,
  );

  if (!flowMultiseries.hasLoaded()) {
    return null;
  }

  return (
    <HistogramGraph
      queryId={QueryId.FlowHistogram}
      queryParams={queryParams}
      multiseriesApi={flowMultiseries}
    />
  );
};
